import React, { useEffect, useRef, useState } from 'react'
import isNull from '../../../utils/NullChecking'
import { Modal, ModalBody } from "react-bootstrap";
import LogoRef from '../../../assets/img/logoRef.png';
import ModalHeader from '../../Setup/Shared/ModalHeader';
import { PdfIcon } from '../../shared/IconsComponent/icons';
import { ServerRequestProtected } from '../../../utils/ServerDataRequest';
import { enumUtil } from '../../../utils/Enum';
import Loader from '../../shared/Loader/Loader';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import RenderFieldPreview from '../../EHR/Intake Form/RenderFieldPreview';
import html2pdf from 'html2pdf.js';
import RejectedIntakeFormPopup from '../RejectedIntakeFormPopup/RejectedIntakeFormPopup';
import NotificationHandler from '../../../utils/NotificationHandler';
import { formatFax } from '../../../utils/Formatting';
import FormatPhoneNumber from '../../../utils/FormatPhoneNumber';
import { useSelector } from 'react-redux';

const IntakePreview = (props) => {

    const { isOpenPopup, ID, intakeFormID: FormID, FormStatus, PatientID, onClose, onCloseSave } = { ...props }

    const API_URL = enumUtil.controller.EHRTemplate;
    const API_URL_Patient = enumUtil.controller.Patient;

    const [intakeFormID, setIntakeFormID] = useState(0);
    const [intakePreviewData, setIntakePreviewData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([])
    const [RejectedConfirmation, setRejectedConfirmation] = useState(false);

    const IntakeFormPreview = () => {
        return (
            <p className="heading">Intake Form Preview</p>
        )
    }

    const componentRef = useRef(null);
    //// Older one for multiple pages with page break ////////////
    // const captureDataAndGeneratePDF = () => {

    //     setIsLoading(true); // Show loader
    //     const element = componentRef.current;
    //     // Temporarily adjust styles to ensure the full content is captured without shifting
    //     const originalOverflow = element.style.overflow;
    //     const originalBodyOverflow = document.body.style.overflow;
    //     // Hide overflow and ensure content is fully visible
    //     element.style.overflow = 'visible';
    //     document.body.style.overflow = 'hidden';
    //     // Wait for the next frame to ensure layout adjustments are rendered
    //     setTimeout(() => {
    //         html2canvas(element, {
    //             useCORS: true, // Allow external resources like fonts and images
    //             scrollX: 0,
    //             scrollY: 0,
    //             scale: 2, // Increase resolution for higher quality
    //             width: element.scrollWidth, // Capture full width
    //             height: element.scrollHeight, // Capture full height
    //         }).then((canvas) => {
    //             // Create a new PDF document
    //             const pdf = new jsPDF('p', 'mm', 'a4');
    //             // Get the image data
    //             const imgData = canvas.toDataURL('image/jpeg', 0.6); // Use JPEG with 70% quality
    //             const imgWidth = 210; // A4 width in mm
    //             const pageHeight = 295; // A4 height in mm
    //             const imgHeight = (canvas.height * imgWidth) / canvas.width;
    //             let heightLeft = imgHeight;
    //             // Add the image to the PDF
    //             let position = 0;
    //             pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    //             heightLeft -= pageHeight;
    //             // If the image is taller than one page, add additional pages
    //             while (heightLeft >= 0) {
    //                 position = heightLeft - imgHeight;
    //                 pdf.addPage();
    //                 pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    //                 heightLeft -= pageHeight;
    //             }
    //             // Save the PDF
    //             pdf.save('IntakeForm.pdf');

    //             //  Get the PDF as bytes (Uint8Array)
    //             const pdfBytes = pdf.output('arraybuffer');

    //             //  Convert to different formats if needed:
    //             // For Base64 string:
    //             const pdfBase64 = pdf.output('datauristring');
    //             console.log("pdfBase64.pdfBytes", pdfBytes, pdfBase64)
    //             // For Blob:
    //             const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });

    //             // For File object:
    //             const pdfFile = new File([pdfBlob], 'IntakeForm.pdf', {
    //                 type: 'application/pdf'
    //             });
    //             // Restore the original overflow
    //             element.style.overflow = originalOverflow;
    //             document.body.style.overflow = originalBodyOverflow;

    //             setIsLoading(false); // Hide loader
    //         }).catch(() => {
    //             // Restore original styles on error
    //             element.style.overflow = originalOverflow;
    //             document.body.style.overflow = originalBodyOverflow;
    //             setIsLoading(false); // Hide loader
    //         });
    //     }, 300); // Adjust timeout if needed
    // };

    ///// Newer one with single page and base64 ////////////////
    const captureDataAndGeneratePDF = async (type) => {
        setIsLoading(true);
        const element = componentRef.current;

        // Save original styles
        const originalOverflow = element.style.overflow;
        const originalBodyOverflow = document.body.style.overflow;

        try {
            // Adjust styles for capture
            element.style.overflow = 'visible';
            document.body.style.overflow = 'hidden';

            // Wait for layout to stabilize
            await new Promise(resolve => setTimeout(resolve, 300));

            // Capture the element
            const canvas = await html2canvas(element, {
                useCORS: true,
                scrollX: 0,
                scrollY: 0,
                scale: 2,
                width: element.scrollWidth,
                height: element.scrollHeight,
                logging: false,
                allowTaint: true
            });

            // Create PDF with custom dimensions
            const imgData = canvas.toDataURL('image/jpeg', 0.8);
            const imgWidth = 210; // A4 width in mm
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            // Create PDF with calculated height (convert mm to pt)
            const pdf = new jsPDF({
                orientation: imgHeight > imgWidth ? 'p' : 'l',
                unit: 'mm',
                format: [imgWidth, imgHeight]
            });

            pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);

            //  Get the PDF as bytes (Uint8Array)
            //             const pdfBytes = pdf.output('arraybuffer');

            //  Convert to different formats if needed:
            // For Base64 string:
            if (type === "download") {

                pdf.save('IntakeForm.pdf');

            } else if (type === 'base64') {

                const pdfBase64 = pdf.output('datauristring');
                const formatedBase64 = pdfBase64.split(',')[1];

                return formatedBase64;

            }


            //             console.log("pdfBase64.pdfBytes", pdfBytes, pdfBase64)
            //             // For Blob:
            //             const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });

            // Download the PDF


        } catch (error) {
            console.error('Error generating PDF:', error);
        } finally {
            // Restore original styles
            element.style.overflow = originalOverflow;
            document.body.style.overflow = originalBodyOverflow;
            setIsLoading(false);
        }
    };

    ////// Intake Form Status /////// 
    const handleIntakeStatus = async (status, formID) => {

        setIsLoading(true);
        let IntakeFormBase64 = await captureDataAndGeneratePDF('base64')
        let obj = {}
        if (status === "Merged") {
            obj = {
                "IntakeStatus": status,
                'PatientID': PatientID + "",
                'IntakeFormBase64': IntakeFormBase64,
                'FileName': 'IntakeForm.pdf'
            }
        } else if (status === "Processed") {
            obj = {
                "IntakeStatus": status,
                'PatientID': PatientID + "",
                'IntakeFormBase64': IntakeFormBase64,
                // 'FileName': 'IntakeForm.pdf'
                'FileName': `${intakePreviewData?.TemplateName || 'IntakeForm'}.pdf`
            }
        } else {
            obj = {
                "IntakeStatus": status,
            }
        }

        let saveModal = {
            "TableName": enumUtil.enumAPITableName.PatientIntakeForm,
            "ID": formID,
            "Data": {
                ...obj
            }
        }

        setIsLoading(true);

        ServerRequestProtected(API_URL_Patient + '/ChangeIntakeFormStatus', 'post', saveModal)
            .then((response) => {
                setIsLoading(false);
                // setIntakeStatusValue(status);
                setRejectedConfirmation(false);
                onCloseSave();
            }).catch((error) => {
                setIsLoading(false);
                NotificationHandler(error.message, enumUtil.enumtoaster.error);
            })
    }

    const handleRejectedConfimation = (formName, formID) => {
        setRejectedConfirmation(true);
        // setSelectedIntakeFormID(formID);
        // setSelectedIntakeFormName(formName);
    }

    const CloseRejectedConfimation = () => {
        setRejectedConfirmation(false);
        // let modalArray = [...IntakeValue];
        // let index = oldIntakeStatus?.index;
        // let Status = oldIntakeStatus?.status;
        // modalArray[index]['Status'] =  Status;
        // setIntakeValue(modalArray);
    }

    const CloseRejectionSave = () => {
        setRejectedConfirmation(false);
        onCloseSave();
    }

    let RejectionConfirmation = "";
    if (RejectedConfirmation) {
        RejectionConfirmation = <RejectedIntakeFormPopup isDiscardChanges={RejectedConfirmation} handleCancelDiscard={CloseRejectedConfimation} onProceedWithDiscardChanges={handleIntakeStatus} FormName={"Rejected"} FormID={FormID} isLoading={isLoading} />
    }

    useEffect(() => {
        if (!isNull(ID)) {

            setIntakeFormID(ID);

            let saveModal = {
                "TableName": enumUtil.enumAPITableName.PatientIntakeForm,
                "Value": ID + "",
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + '/GetPatientFilledForm', 'post', saveModal)
                .then((response) => {
                    setIntakePreviewData(response);
                    setData(response.Data);
                    setIsLoading(false)
                }).catch((error) => {
                    console.log(error)
                    setIsLoading(false)
                })
        }
    }, [ID])

    // const MarkAsProcessed = () => {
    //     setIsLoading(true)
    //     ServerRequestProtected(API_URL_Patient + "/UpdateIntakeStatus", 'post', {
    //         "TableName": enumUtil.enumAPITableName.PatientIntakeForm,
    //         "Value": ID,
    //         "Data": {
    //             "IntakeStatus": "Processed"
    //         }
    //     }).then((response) => {
    //         setIsLoading(false)
    //         setData(response)
    //         NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
    //         onClose()
    //     }).catch((error) => {
    //         setIsLoading(false)
    //         NotificationHandler(error.response?.data || "Error loading insurance data", enumUtil.enumtoaster.error)
    //     })
    // }

    let patientData = intakePreviewData?.PatientData?.[0] || null;

        const ThemeConfiguration = useSelector((state) => state.Theme?.theme) || JSON.parse(localStorage.getItem("themeConfig") || "null");
    return (
        <>
            {/* <Modal show={ } onHide={ } backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 za-Intakeform-preview table-default-design">
                <Modal.Body>
                    <div className="d-flex flex-column gap-12" >
                        {isLoading ? <Loader /> : null}
                        {RejectionConfirmation}
                        <div className="d-flex align-items-center justify-content-between mb-12 px-10">
                            <div className="">

                                <p className="heading dark-clr fs-14">Intake Form Preview</p>
                            </div>
                            <div className="d-flex align-items-center gap-2 ar_footer">
                                {FormStatus === "Submitted" ?
                                    <>
                                        <button className={"btn btn-danger px-10 h-100"} onClick={() => handleRejectedConfimation('Rejected', FormID)}>Rejected</button>
                                        <button className={"btn btn-greenn px-10 h-100"} onClick={() => handleIntakeStatus("Merged", FormID)}>Merged</button>
                                    </>
                                    :
                                    <p class={`text fst-italic font-m ${FormStatus === "Merged" ? "Paid-clr" : FormStatus === "Rejected" ? "Rejected-clr" : ''}`}>
                                        {FormStatus}
                                    </p>

                                }
                                <div onClick={() => captureDataAndGeneratePDF('download')}><PdfIcon /></div>
                                <i className="icon-x-cros fs-20 dark-clr" ></i>
                            </div>
                        </div>
                        <div className='hover-scrollbar Scroll d-flex flex-column gap-12' ref={componentRef}>
                            <div className="d-flex justify-content-between align-items-center br-bottom-1 za_br_light mx-10 pb-1">
                                <div>
                                    <img src={ } alt="" width="120px" />
                                </div>

                                <div className="text-center">
                                    <p className="heading fs-11 drk-green-clr">{intakePreviewData?.PracticeData?.[0]?.PracticeName}</p>
                                    <p className="text ">{intakePreviewData?.PracticeData?.[0]?.Address}</p>
                                </div>
                                <div className="d-flex gap-1">
                                    <div>
                                        {intakePreviewData?.PracticeData?.[0]?.EmailAddress && <p className="text font-m fs-10">Email:</p>}
                                        {intakePreviewData?.PracticeData?.[0]?.Phone && <p className="text font-m fs-10">Phone #</p>}
                                    </div>
                                    <div>
                                        <p className="text fs-10">{intakePreviewData?.PracticeData?.[0]?.EmailAddress}</p>
                                        <p className="text fs-10">{intakePreviewData?.PracticeData?.[0]?.Phone}</p>
                                    </div>
                                </div>
                            </div>
                            {patientData ?
                                <div className="patient-info d-flex justify-content-between align-items-center mx-10">
                                    <p className="heading fs-11">Patient: {patientData?.Patient} <span className="text font-m"> {patientData?.DOB}  {patientData?.Age ? `(${patientData.Age} Y)` : ''} {patientData?.Gender}</span></p>
                                    <p className="heading fs-11">Provider: {patientData?.Provider}</p>
                                </div> : null}
                            <div className="px-10">
                                {intakePreviewData?.TemplateName &&
                                    <div className="Health-screen px-3 py-1 mb-12">
                                        <p className="heading fs-13 text-white">{intakePreviewData?.TemplateName}</p>
                                    </div>}
                                <div className="Form-body d-flex flex-column gap-10">
                                    {data?.[0]?.['items']?.map(it => {
                                        return <RenderFieldPreview item={it} setItem={setData} activeAccordion={'Intake Form'} />
                                    })}
                                </div>
                            </div>

                            <div className="d-flex justify-content-center align-items-center pt-1 gap-6 br-top-1 za_br_light">
                                <p className="text font-m fs-10 ar-light-color">Date:</p>
                                <p className="text fs-10 ar-light-color">{data?.[0]?.SubmitDate}</p>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal> */}

            <Modal show={isOpenPopup} onHide={isOpenPopup} backdrop="static" keyboard={false} centered dialogClassName="ar_merg-info-form-popup ar-merge-form-preview">
                <Modal.Body>
                    {isLoading ? <Loader /> : null}
                    {console.log("IntakeData", data, intakePreviewData)}

                    <div className="ar_native_pdf_design pb-15">
                        <div className="ar_print-header">
                            <div className="d-flex align-items-center justify-content-center gap-2 mb-12 pt-15 ar_print-header {">
                                <i className="icon-Icon-metro-cross fs-20" onClick={() => onClose()}></i>
                            </div>
                            <div className="d-flex align-items-center justify-content-between pb-1-5 br-bottom-1 za_br_light px-10">
                                {intakePreviewData.SubmittedBy === 'Admin' ?
                                 <p className="text fs-11 ar-light-color">Submitted By Date: {intakePreviewData?.SubmittedByName}, {intakePreviewData?.SubmitDate} </p>
                                    :
                                    <p className="text fs-11 ar-light-color">Submitted on {data?.[0]?.SubmitDate || 'N/A'} </p>
                                }

                                {(intakePreviewData?.Status && intakePreviewData?.Status !== 'Processed') ?
                                    <p className="text validate-color font-m cursor-pointer" onClick={() => handleIntakeStatus("Processed", FormID)}>Mark As Processed</p> : null
                                }
                            </div>
                        </div>

                        <div className='d-flex flex-column gap-10'>

                            <div className="ar-scroll-content d-flex flex-column justify-content-between">
                                <div className='d-flex flex-column gap-10 px-10 pt-15 pb-15' ref={componentRef}>
                                    <div className="d-flex align-items-center justify-content-center pat-det-header">
                                        <p className="heading text-white">{intakePreviewData?.TemplateName || 'N/A'}</p>
                                    </div>


                                    <div className="d-flex align-items-center justify-content-between br-bottom-1 py-1 px-2 za_br_light">
                                        <div className="">
                                            <img src={intakePreviewData?.PracticeData?.[0]?.img} alt="" style={{ maxHeight: '60px' }} />
                                        </div>
                                        <div className="text-center">
                                            <p className='heading validate-color fs-14'>{intakePreviewData?.PracticeData?.[0]?.PracticeName}</p>

                                            <p className="text text-black">{intakePreviewData?.PracticeData?.[0]?.Address}</p>

                                        </div>
                                        <div className="d-flex gap-10">
                                            <div className="">
                                                <p className='text text-black font-m pb-2px'>Tel:</p>
                                                <p className='text text-black font-m'>Fax:</p>
                                            </div>
                                            <div className="">
                                                <p className='text text-black  pb-2px'>{!isNull(intakePreviewData?.PracticeData?.[0]?.Phone) ? FormatPhoneNumber(intakePreviewData?.PracticeData?.[0]?.Phone) : intakePreviewData?.PracticeData?.[0]?.Phone || 'N/A'}</p>
                                                <p className='text text-black '>{formatFax(intakePreviewData?.PracticeData?.[0]?.fax) || 'N/A'}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="d-flex flex-column gap-10">
                                        {data?.[0]?.['items']?.map(it => {
                                            return <RenderFieldPreview item={it} setItem={setData} activeAccordion={'Intake Form'} />
                                        })}
                                    </div>
                                </div>
                                <div className="text-center pt-1-5 br-top-1 za_br_light print-footer mt-5">
                                    <p className="text ar-light-color">By {ThemeConfiguration?.configuration?.company?.name}
                                        (<a href="https://starhealthcare.co" className="ar-hover-text ar-light-color text" target="_blank" rel="noopener noreferrer">https://starhealthcare.co</a>) </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal >
        </>

    )
}

export default IntakePreview
